import { render } from "./SurveyPage01.vue?vue&type=template&id=f451d594&scoped=true"
const script = {}

import "./SurveyPage01.vue?vue&type=style&index=0&id=f451d594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f451d594"]])

export default __exports__